import React, { useEffect, useRef, useState } from "react";
import { withStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";

import constants from "utils/constants";
import {
  apiGetUserWalmartAuthorizeStatus,
  apiUserDisconnectSpApi,
  apiUserWalmartUnAuthorize
} from "api/user";
import { connectAutoDispatch } from "redux/reduxConnect";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import { Button, Space, Spin, Typography } from "antd";
import WalmartSloganIntegration from "static/img/wm-slogan-integration.jpg";


const styles = theme => ({
  main: {
    display: "block", // Fix IE 11 issue.
    width: "100%",
    [theme.breakpoints.up(700)]: {
      width: 640,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paperHeader: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}`
  },
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(3)}`
  },
  status: {
    fontSize: 16,
    "& > span": {
      textTransform: "capitalize"
    }
  },
  authorizeBtn: {
    marginTop: `${theme.spacing(2)}`,
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& button": {
      minWidth: 100,
      marginTop: 10
    }
  }
});

const WalmartAuthorizeStatus = props => {
  const { classes } = props;
  const [authorized, setAuthorized] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    checkTokenStatus();
  }, []);

  const checkTokenStatus = async () => {
    setLoading(true);
    try {
      const { data } = await apiGetUserWalmartAuthorizeStatus();
      setAuthorized(data.authorized);
      setError(null);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setAuthorized(false);
      if (err && err.data && !err.data.data) {
        setError("Failed to check authorization status");
        console.error(err);
      }
    }
  };

  const handleAuthorize = marketplace => {
    const clientId = `${process.env.WALMART_CLIENT_ID}`;
    const redirectUri = `${process.env.WALMART_CLIENT_REDIRECT_URL}`;
    const state = `marketplace-${marketplace}`;
    const nonce = Math.random()
      .toString(36)
      .substring(2);

    const authUrl = `https://login.account.wal-mart.com/authorize?responseType=code&clientId=${clientId}&redirectUri=${encodeURIComponent(
      redirectUri
    )}&nonce=${nonce}&state=${state}&clientType=seller`;

    localStorage.setItem("walmart_oauth_state", state);
    localStorage.setItem("walmart_oauth_nonce", nonce);
    localStorage.setItem("walmart_success", "true");

    window.location.href = authUrl;
  };

  const handleUnAuthorize = async () => {
    setLoading(true);
    await apiUserWalmartUnAuthorize()
      .then(() => {
        setAuthorized(false);
        setLoading(false);
        setError(null);
      })
      .catch(err => {
        setLoading(false);
        setAuthorized(true);
        if (err && err.data && !err.data.data) {
          setError("Failed to disconnect");
          console.error(err);
        }
      });

    localStorage.removeItem("walmart_oauth_state");
    localStorage.removeItem("walmart_oauth_nonce");
  };

  return (
    <Space
      direction="vertical"
      size="large"
      style={{ width: "100%", display: "flex", marginTop: "20px", alignItems: "center" }}
    >
      <Paper className={classes.paperHeader}>
        <Typography variant="h6" style={{ width: "100%", textAlign: "center" }}>
          Walmart Integration Status
        </Typography>
      </Paper>
      <Paper className={classes.paper}>
        <div className={classes.authorizeBtn}>
          {authorized !== null ? (
            authorized ? (
              <>
                <strong className="has-text-primary connected-text">Connected successfully</strong>
                <button className="button is-small is-danger" onClick={() => handleUnAuthorize()}>
                  Disconnect
                </button>
              </>
            ) : (
              <>
                <p className="red-c">Not connected</p>
                <p>Click button below to connect.</p>
                <button className="button is-small is-info" onClick={() => handleAuthorize("US")}>
                  Connect
                </button>
              </>
            )
          ) : (
            "..."
          )}
          {error ? error : null}
        </div>
        <Space direction="vertical" style={{ display: "flex", alignItems: "center", marginTop: 40 }}>
          <Typography.Title level={5}>Don't have a Walmart Account?</Typography.Title>
          <Typography.Text style={{ fontSize: 16 }}>
            Grow your business with AsinZen and Walmart Marketplace.
          </Typography.Text>
          <div style={{ maxWidth: 800 }}>
            <img src={WalmartSloganIntegration} />
          </div>
          <div>
            <Button
              type="link"
              href="https://seller.walmart.com/signup?q=&origin=solution_provider&src=001KW00001NaLSf"
              target="_blank"
              size="large"
            >
              Join Walmart Marketplace
            </Button>
          </div>
        </Space>
      </Paper>
    </Space>
  );
};

export default withStyles(styles)(
  connectAutoDispatch(state => ({ userInfo: state.userState.userInfo }), {})(WalmartAuthorizeStatus)
);
